export default __webpack_public_path__ + "static/media/icon-algocare-n.3c2dda4e.webp";